<script>
/**
 * ****************************************************************************
 * @description     :   Main component for MNG_System006
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import MNG_System006 from '@/views/move/mng_system/MNG_System006/store';
import messages, { MSG_TITLE, MSG_TYPE } from '@/utils/messages';

/**
 * Import template
 */
import template from './template.html';
import '../style.scss';
import helpers from '@/utils/helpers';

/**
 * Define component chat for show page chat
 */
var Template2_MNG_System006 = {
    components: {
        template
    },
    template: template,
    props: {
        departmentCode: {
            type: [Number, String],
            default: null
        },
        departmentName: {
            type: [String],
            default: null
        },
        modeAuto: {
            type: [Number, String],
            default: null
        }
    },
    beforeCreate() {
        if (!store.hasModule('MNG_System006')) {
            store.registerModule('MNG_System006', MNG_System006);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.referData();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.hideModalMessage();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'MNG_Master004_Detail',
            validRules: {
                listProcessDayFrom: 'required',
                listProcessDayTo: 'required'
            },
            errors: [],
            screen_template: 1
        };
    },
    watch: {
        modeAuto(val) {
            if (val == 0) {
                this.onInitScreen();
            }
        }
    },
    computed: {
        ...mapState('app', ['S9007', 'zoom']),
        ...mapState('MNG_System006', ['selectOptionKey', 'totalRows', 'listData', 'msgNoData', 'isSuccess', 'data_select', 'listKubun'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('MNG_System006', ['setDataTemplate', 'resetDataInit', 'getData']),
        ...mapActions('MNG_System006', ['actionSearch', 'getData', 'saveBasicChargeInformation', 'getListTitle', 'saveListKubun']),
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        clearData(data) {
            if (data != '') {
                helpers.removeAllRequireInput();
                this.hideHeaderError();
            }
        },
        referData() {
            this.getListTitle();
        },
        save() {
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: this.modeAuto == 0 ? MSG_TITLE.C001 : MSG_TITLE.C002,
                content: this.modeAuto == 0 ? messages.C001 : messages.C002,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (ok) {
                        let formData = new FormData();
                        formData.append(
                            'data',
                            JSON.stringify({
                                ...this.listKubun
                            })
                        );
                        this.saveListKubun({
                            body: formData,
                            callback: () => {
                                this.showModalMessage({
                                    title: this.modeAuto == 0 ? MSG_TITLE.S001 : MSG_TITLE.S002,
                                    content: this.modeAuto == 0 ? messages.S001 : messages.S002,
                                    okText: 'OK'
                                });
                            },
                            onError: (errorMessage) => {
                                this.showHeaderError([errorMessage ?? messages.E999]);
                            }
                        });
                    }
                }
            });
        }
    }
};
export default Template2_MNG_System006;
</script>
